import React from 'react';
import { FadeIn } from './FadeIn';
import { TrendingDown } from 'lucide-react';
export function SavingsSection() {
  return <section className="bg-brown-50 py-12 md:py-16" data-id="element-246">
      <div className="max-w-3xl mx-auto px-6" data-id="element-247">
        <FadeIn data-id="element-248">
          <h2 className="text-2xl md:text-4xl mb-10 text-center whitespace-nowrap" data-id="element-249">
            Realistic Savings (Not Hype)
          </h2>

          <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12 mb-4" data-id="element-250">
            <p className="text-lg text-brown-800 mb-8 text-center font-medium" data-id="element-251">
              Women using this framework have reported:
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10" data-id="element-252">
              {['$600 reductions', '$1,300 corrections', '20–40% balance adjustments', 'Successful appeals that were initially denied'].map((item, i) => <div key={i} className="flex items-center bg-cream-50 p-4 rounded-lg border border-cream-100" data-id="element-253">
                  <TrendingDown className="w-5 h-5 text-green-600 mr-3 flex-shrink-0" data-id="element-254" />
                  <span className="font-medium text-brown-900" data-id="element-255">{item}</span>
                </div>)}
            </div>

            <div className="text-center border-t border-cream-100 pt-8" data-id="element-256">
              <p className="text-lg font-semibold text-brown-800 mb-4" data-id="element-257">
                If you overpay even $1,000 per year…
              </p>
              <p className="text-brown-600 mb-1" data-id="element-258">That's:</p>
              <div className="space-y-1 mb-4" data-id="element-259">
                <p className="text-xl font-bold text-terracotta-600" data-id="element-260">
                  $5,000 over 5 years
                </p>
                <p className="text-xl font-bold text-terracotta-600" data-id="element-261">
                  $10,000 over 10 years
                </p>
              </div>
              <p className="text-brown-700 mb-2" data-id="element-262">
                That's a family vacation. Emergency savings. Debt eliminated.
              </p>
              <p className="text-brown-800 font-semibold" data-id="element-263">
                Overpaying quietly compounds.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}